import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: '/api', // 本地开发时由 vue.config.js 代理
  timeout: 100000
})

service.interceptors.request.use(
  config => {
    // 自动携带 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => response.data,
  error => {
    Message.error(error.response?.data?.message || '网络错误')
    return Promise.reject(error)
  }
)

export default service 